import { clearSelectedPatient } from "../store/slices/selectedPatientSlice";
import { removeTempPatientId } from "./openPatientTab";

export const convertInchesToFeetInches = (heightInInches) => {
  if (heightInInches == null) return null;

  // Normalize input
  let inchesValue;

  if (typeof heightInInches === "number") {
    inchesValue = heightInInches;
  } else if (typeof heightInInches === "string") {
    inchesValue = parseFloat(heightInInches); // handles "70", "70in", "70 inches"
  }

  if (isNaN(inchesValue)) return null;

  const feet = Math.floor(inchesValue / 12);
  const inches = Math.round(inchesValue % 12); // round for decimals

  return {
    feet,
    inches,
    formatted: `${feet}'${inches}"`,
  };
};

export const clearPatientData = (dispatch, callDispatch = true) => {
  if (callDispatch) {
    dispatch(clearSelectedPatient());
  }

  sessionStorage.removeItem("patientId");
  removeTempPatientId();
};
